import React from 'react';
import Cookies from 'js-cookie';
import { useSearchParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { MEMBER_URL, SUBASTAS_URL } from '../../constants/Constants';
import winner from '../../assets/winner.svg';

const FinalWinnerComp = () => {
  const [searchParams] = useSearchParams();

  const decodeUTF8 = (str) => {
    return decodeURIComponent(escape(window.atob(str)));
  };

  const name = decodeUTF8(searchParams.get('name'));
  const auction = decodeUTF8(searchParams.get('title'));

  const nameURL = searchParams.get('name');
  const auctionURL = searchParams.get('title');
  const rewardTypeURL = searchParams.get('rewardType');
  const auctionIdURL = searchParams.get('auctionId');

  // name=QWRyaWFuIFMu
  // title=Q0FTQSBNw5xJIENPTiBUVVMgUFVOVE9TIFBSRU1JRVI=
  // rewardType=UFJPRFVDVA==
  // memberAccount=MDA4MTc0MTgyMDU=
  // auctionId=MTU0
  // utm_source=clubpremier
  // utm_medium=email
  // utm_term=ganador
  // utm_content=cta_confirmar_mis_datos
  // utm_campaign=subastas

  const handleLogin = () => {
    Cookies.set('redirect', `subastas-ganador/?name=${nameURL}&title=${auctionURL}&rewardType=${rewardTypeURL}&auctionId=${auctionIdURL}`);
    window.location = `${MEMBER_URL}/login?url=${SUBASTAS_URL}/#/subastas-ganador`;
  };

  return (
    <Container className="mt-60">
      <Row className="justify-content-center">
        <Col lg={8} className="justify-content-center">
          <Row>
            <Col lg={6}>
              <Row>
                <Col lg={12}>
                  <h2>{`¡Felicidades ${name}, eres el ganador de la Subasta!`}</h2>
                  <p className="my-30 text-tangaroa">
                    Para hacer entrega de tu premio
                    <span className="font-weight-bold mx-1 text-tangaroa">{auction}</span>
                    es necesario que confirmes tus datos dando clic en el botón ‘Iniciar sesión’.
                  </p>
                </Col>
                <Col lg={12} className="text-right">
                  <button type="button" className="btn btn-primary" onClick={handleLogin}>
                    Iniciar sesión
                  </button>
                </Col>
              </Row>
            </Col>
            <Col lg={6} className="mb-60">
              <img src={winner} alt="final-winner-img" />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default FinalWinnerComp;
